import React, { createContext, useState, useContext, useCallback } from 'react';

// Contexto para compartilhar estado de filtros entre PropertyHeader e PropertyDashboard
const PropertyFilterContext = createContext();

/**
 * Provider para disponibilizar os estados de filtros da propriedade
 * para todos os componentes da árvore.
 */
export const PropertyFilterProvider = ({ children }) => {
  // Estado para armazenar códigos CAR selecionados
  const [selectedCarCodes, setSelectedCarCodes] = useState([]);

  // Estado para armazenar códigos SIGEF selecionados
  const [selectedSigefCodes, setSelectedSigefCodes] = useState([]);

  // Estado para armazenar códigos CAFIR selecionados
  const [selectedCafirCodes, setSelectedCafirCodes] = useState([]);

  // Método para alternar seleção de um código CAR
  const toggleCarCode = useCallback((code) => {
    setSelectedCarCodes((prev) => {
      if (prev.includes(code)) {
        return prev.filter((c) => c !== code);
      } else {
        return [...prev, code];
      }
    });
  }, []);

  // Método para alternar seleção de um código SIGEF
  const toggleSigefCode = useCallback((code) => {
    setSelectedSigefCodes((prev) => {
      if (prev.includes(code)) {
        return prev.filter((c) => c !== code);
      } else {
        return [...prev, code];
      }
    });
  }, []);

  // Método para alternar seleção de um código CAFIR
  const toggleCafirCode = useCallback((code) => {
    setSelectedCafirCodes((prev) => {
      if (prev.includes(code)) {
        return prev.filter((c) => c !== code);
      } else {
        return [...prev, code];
      }
    });
  }, []);

  // Método para selecionar todos os códigos CAR
  const selectAllCarCodes = useCallback((codes) => {
    setSelectedCarCodes(codes);
  }, []);

  // Método para selecionar todos os códigos SIGEF
  const selectAllSigefCodes = useCallback((codes) => {
    setSelectedSigefCodes(codes);
  }, []);

  // Método para selecionar todos os códigos CAFIR
  const selectAllCafirCodes = useCallback((codes) => {
    setSelectedCafirCodes(codes);
  }, []);

  // Valor do contexto
  const value = {
    selectedCarCodes,
    selectedSigefCodes,
    selectedCafirCodes,
    toggleCarCode,
    toggleSigefCode,
    toggleCafirCode,
    selectAllCarCodes,
    selectAllSigefCodes,
    selectAllCafirCodes,
    // Adicionando acesso direto às funções de setState para casos específicos
    setSelectedCarCodes,
    setSelectedSigefCodes,
    setSelectedCafirCodes,
  };

  return <PropertyFilterContext.Provider value={value}>{children}</PropertyFilterContext.Provider>;
};

// Hook personalizado para acessar o contexto
// eslint-disable-next-line react-refresh/only-export-components
export const usePropertyFilters = () => {
  const context = useContext(PropertyFilterContext);
  if (context === undefined) {
    throw new Error('usePropertyFilters deve ser usado dentro de um PropertyFilterProvider');
  }
  return context;
};
